import React from 'react';
import {
  Provider, defaultTheme,
} from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import GlobalData from '../utils/GlobalData';

export default function ProductPage(props) {
  const { data, onProductSelect } = props;

  // const productList = data.map((product, index) => <button type="button" key={index.toString()} onClick={() => onProductSelect(product)} >{product.title}</button>);
  const productList = data.map((product, index) => <button type="button" key={index.toString()} onClick={() => onProductSelect(product)} >{product.displayName}</button>);

  return (
    <div className="ScreenContainer">
      <div className="ContentContainer">
        <div className="WelcomeText">{GlobalData.translatedStrings['app.productScreen.title']}</div>
        <div className="SubText">{GlobalData.translatedStrings['app.productScreen.subtitle']}</div>
        <div className="ProductsContainer">
          <div className="SingleProductContainer">
            <div className="SingleProduct">
              <Provider theme={defaultTheme}>
                {productList}
              </Provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProductPage.propTypes = {
  onProductSelect: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};
